export function LandingHero() {
  return (
    <section className="relative mb-8 border-b border-[var(--border-subtle)] pb-8">
      <div
        className="pointer-events-none absolute -left-6 top-0 h-24 w-40 rounded-full bg-[var(--accent-muted)] blur-3xl"
        aria-hidden
      />
      <p className="relative text-xs font-semibold uppercase tracking-[0.12em] text-[var(--brand-primary)]">
        New assessment
      </p>
      <h1 className="relative mt-3 text-3xl font-bold tracking-tight text-[var(--text-primary)] sm:text-4xl">
        Start a FinOps Assessment
      </h1>
      <p className="relative mt-4 text-base leading-relaxed text-[var(--text-secondary)]">
        Upload cost data, architecture files, or describe the problem in plain language. The agent
        will ask focused follow-ups, tie findings to your scope, and produce recommendations you
        can take to engineering and finance.
      </p>
    </section>
  );
}
